// extracted by mini-css-extract-plugin
export var hidden = "_ny-1";
export var visible = "_ny-0";